.listItem {
  display: flex;
  align-items: center;
  padding: 0;
}

.button {
  padding: 4px;
  margin: 0;
}

.entityAvatar {
  color: var(--tuna-palette-grey-100);
}

.listItemText {
  flex: 1;
  min-width: 0;
}

.primaryText {
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.primarySmall {
  font-size: 12px;
}

.primaryTiny {
  font-size: 10px;
}

.secondaryText {
  color: var(--tuna-palette-text-secondary);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.secondarySmall {
  font-size: 10px;
}

.secondaryTiny {
  font-size: 8px;
}

.secondaryNormal {
  font-size: 12px;
}

.listItemAvatar {
  display: flex;
  align-items: center;
}

.listItemAvatarTiny {
  min-width: 4px;
}

.listItemAvatarDefault {
  min-width: 40px;
}
